import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { PaginationProps, Switch, Tooltip, TreeSelect } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ICustomer } from '../../../../../api/Customer_V2/customerApi_V2';
import { addCustomerByGroup, addListGroup, addOperatorFilterGroup, getListAllCustomer, getListConditionMatched, getListConditionUnMatched, getListCustomerByGroup, getListOperatorFieldGroup, IOperatorFieldConditionsGroup, IOperatorFieldGroup, IOperatorFieldGroupV2, IVConditionFilterADD, IVConditionFilterV2 } from '../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { filterInfoOperatoToConditions } from '../../../../../apiSync/customerGroup/customerGroupApi';
import { group_share, group_share_active, info_cicrle, user_private, user_private_active } from '../../../../../components/ExportImgFigma';
import useDebounce from '../../../../../hook/useDebounce';
import useLoading from '../../../../../hook/useLoading';
import useThrottle from '../../../../../hook/useThrottle';
import useToast from '../../../../../hook/useToast';
import { capitalizeEachWord, getLastIdList, getWidthFromHeader, renderValueAsJSX } from '../../../../../until';
import { ColumnKey } from '../../../Tabs/CarListCardClone';
import { convertTreeForAntd, EDisplayGroupType, useCustomerGroupContext } from '../../indexV2';
import { ISelectedUserAccount } from '../EditGroup/ConditionEdit/EG_Decentralization';
import ModalAddAndEditCondition, { initInfoOperator, toAddPayload } from '../Modal/ModalAddAndEditCondition';
import { NodeEvent, TreeNode } from '../SideBar';
import AG_ConditionComponent from './Component/AG_ConditionComponent';
import AG_CustomerList from './Component/AG_CustomerList';
import AG_PrivateNoAutomatic from './Component/AG_PrivateNoAutomatic';
import AG_SharingNoAutomatic from './Component/AG_SharingNoAutomatic';
import { CONDITIONGROUP } from './Component/PrivateGroup/AG_PrivateAutomatic';
import { NO_DATA, NO_VIEW } from '../../../../../services/data';
import { ICustomerFields } from '../../../../../api/salesSericeCustomer/salesSericeCustomerApi';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import { number } from 'echarts';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';
import { BATCH_SIZE } from '../../../../../env';
import { gListOperatorFieldConditionsGroupByInfo } from '../../untilGroupCustomer';
import { buildOptions } from '../../../../CustomersV2/indexV2';
dayjs.locale('vi');


export enum GROUPTYPE {
  PRIVATE = 0,   // Nhóm riêng tư
  SHARED = 1,    // Nhóm chia sẻ
}

export enum CONDITION {
  NO = 0,   // Nhóm riêng tư
  YES = 1,    // Nhóm chia sẻ
}

export const dataTypeGroup = [
  "Nhóm riêng tư", "Nhóm chia sẻ"
]

export const ConditionGroup = [
  { label: 'Thỏa mãn tất cả các điều kiện (AND)', value: 0 },
  { label: 'Tuỳ chỉnh', value: 1 },
  { label: 'Tất cả khách hàng', value: 2 },
];

export interface IPagination {
  current: number;
  pageSize: number;
  total: number;
}

export interface IInforAddGroup {
  // id: number
  title: string
  type: number
  status: number
  // listCustomer: number[]
  unitScopeId?: number | null
  level?: number
  parentId?: number
  description?: string
}

const initInforAddGroup: IInforAddGroup = {
  title: "",
  type: 0,
  status: 0,
  unitScopeId: null,
  level: undefined,
  parentId: undefined,
  description: undefined
};

export interface IDataFilterGroupList {
  search?: string;
  listUnit?: number[]
  listCategoryCar?: number[]
}

export enum AddType {
  Manual = 0,   // Thêm thủ công
  Auto = 1      // Thêm tự động
}

// Định nghĩa interface sử dụng enum
export interface ISelectedCustomer {
  customerId: number;
  title?: string
  addType: AddType;
  isDeleted?: 0 | 1;
}

export interface IOperator {
  logicOperator: 'AND' | 'OR' | 'ALL'
  fieldId?: number
  conditionId?: number
  fieldConditionData?: IOperatorFieldConditionsGroup[]
  inputType?: 'string' | 'dropdown' | 'date' | 'number'
  inputData?: any
  isAdd: boolean

  //nơi lưu giá trị
  valueText?: string
  valueNumber?: number
  valueNumberMin?: number
  valueNumberMax?: number
  valueDate?: string
  valueDateStart?: string
  valueDateEnd?: string
  options?: any
}
export const initOperator: IOperator = {
  logicOperator: 'AND',
  isAdd: false,
}
export const dataDefaulFilterList: IDataFilterGroupList = {
  listUnit: [],
  listCategoryCar: [],
};

export type TypeConditionPreview = "filter" | "condMatched" | "condUnmatched"

export interface ILastIdGroupCustomer {
  noCond?: number,
  condMatched?: number,
  condUnmatched?: number
}


//--------------------

interface Props {
}

export const generateColumnsFromCodesAgGridReactGroup = (
  codes: ColumnKey[],
  fields: ICustomerFields[],
  actionColumn?: ColDef<any, any>,
  onToggleStatus?: (id: number, next: boolean, rowData: any) => void,
  hasToolTip?: string[]
): ColDef[] => {
  const baseColumns = codes
    ?.map(code => {
      const field = fields.find(f => f.fieldCode === code);
      if (!field) return null;

      return {
        headerName: field.fieldLabel,
        // headerComponent: FilterHeader,
        field: field.fieldCode,
        colId: field.fieldCode,
        sortable: true,
        pinned: field.fieldCode === "cus_name" ? 'left' : undefined,
        lockPosition: field.fieldCode === "cus_name" ? 'left' : undefined,
        suppressMovable: field.fieldCode === "cus_name" ? true : undefined,
        width: getWidthFromHeader(field.fieldLabel),
        cellRenderer: (params: any) => {
          const value = params.value
          // ✅ Nếu cột là cus_name thì render span clickable
          if (field.fieldCode === "cus_name") {
            return (
              <span
                style={{ cursor: "pointer", color: "#096DD9" }}
                onClick={() => {
                  if (onToggleStatus) {
                    onToggleStatus(params.data?.id, true, params);
                  }
                }}
              >
                {renderValueAsJSX(value, field.fieldCode)}
              </span>
            );
          }

          if (hasToolTip?.includes(field.fieldCode)) {
            const arr = value?.toString()?.split(',').map((item: any) => item.trim());
            return (

              arr?.length > 1
                ?
                <div className='custom-page-css flex items-center gap-1'>
                  <span>{arr?.[0]}</span>
                  <Tooltip

                    placement="right"
                    color="white"

                    title={
                      <div
                        style={{
                          maxHeight: 400,       // chiều cao cố định
                          overflowY: "auto",    // bật scroll dọc
                        }}
                        className="space-y-2"
                      >
                        {
                          arr?.map((item: any, i: any) => (
                            <div key={i} className="flex items-center gap-2">
                              <span className="custom-page-css fs-14 text-000000">

                                {item}
                              </span>
                            </div>
                          ))
                        }
                      </div>
                    }
                  >
                    <div className=" action-icons action-icons-bage-2  px-2 fs-14 cursor-pointer ml-1" style={{ height: 24 }}>
                      <div className="font-light color-bage">
                        {arr?.length}
                      </div>
                      <img src={info_cicrle} alt="Avatar" />
                    </div>
                  </Tooltip>
                </div >
                :
                <span>{value}</span>

              // <span>{arr?.length > 1 ? arr.map((item: string, index: number) => (
              //   <span key={index}>{item}</span>
              // )) : 




              // <Tooltip title={value}>
              //   <div
              //     style={{
              //       display: 'flex',
              //       flexDirection: 'column',
              //       gap: 2,
              //       maxHeight: 200,
              //       padding: '2px 4px',
              //       overflowY: 'auto',
              //     }}
              //   >
              //     {arr?.length > 0 ? arr.map((item: string, index: number) => (
              //       <div key={index}>{item}</div>
              //     )) : <span>{value}</span>}
              //   </div>
              // </Tooltip>
            );
          }

          return renderValueAsJSX(value, field.fieldCode);
        }
      } as ColDef;
    })
    .filter(Boolean) as ColDef[];

  return actionColumn ? [actionColumn, ...baseColumns] : baseColumns;
};


export const limitSyncListCustomerGroupByFilter = 1000

const AddNewGroup: React.FC<Props> = ({
}) => {
  useEffect(() => {

    return () => {
      setSelectIdCondMatchedCustomers([])
      setSelectedCondIdUnmatchedCustomers(new Set())
      setInfoCondFilterSync({ matched: [], unMatched: [] })
    }
  }, [])

  const pushLoading = useLoading()
  const pushToast = useToast();
  const navigator = useNavigate()
  const { unitTemp } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const {
    isModalLoadingSync,
    infoOperator,
    displayType, dataFilterList, inforNodeEvent,
    dataFieldsActive, ColumnsMapShow, listGroup,
    setIsModalLoadingSync, setIsLoadingListUnmatchedSync,
    setDataFilterList, setInforNodeEvent,
    onSubmitFormModalAdd,
    setInfoOperator
  } = useCustomerGroupContext();


  const skipCondMatchedRef = useRef(false);

  // Snapshot KH addType=1 lấy từ API lần đầu — dùng để detect KH bị bỏ checkbox
  const initialAutoCustomersRef = useRef<Set<number>>(new Set());

  const [paginationCustomers, setPaginationCustomers] = useState({ current: 1, pageSize: 10, total: 0 });

  const [inforAddGroup, setInforAddGroup] = useState<IInforAddGroup>(initInforAddGroup)

  const [selectedIdCustomerV9, setSelectedIdCustomerV9] = useState<ISelectedCustomer[]>([]);
  const [selectedIdAccount, setSelectedIdAccount] = useState<ISelectedUserAccount[]>([]);
  const [idCustomerLast, setIdCustomerLast] = useState<{ condUnmatched?: number, condMatched?: number }>({ condUnmatched: undefined, condMatched: undefined });

  const [lastId, setLastId] = useState<ILastIdGroupCustomer>()
  const [searchListFilter, setSearchListFilter] = useState<string>('')

  //Kh không dk--------------------
  const [dataFilterListNoCondCustomers, setDataFilterListNoCondCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)


  const [listCustomerNoCondCustomers, setlistCustomerNoCondCustomers] = useState<any[]>([])
  //Kh không dk--------------------

  //Kh có dk--------------------
  const [isModalCondition, setModalCondition] = useState<boolean>(false)
  const [loadingTableModal, setLoadingTableModal] = useState<boolean>(false)


  const [sLOperatorFieldGroup, setSLOperatorFieldGroup] = useState<IOperatorFieldGroupV2[]>([])

  const [dataFilterListCondUnmatchedCustomers, setDataFilterListCondUnmatchedCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)
  //thiếu matched
  const [paginationCondMatchedCustomers, setPaginationCondMatchedCustomers] = useState({ current: 1, pageSize: 10, total: 0 });
  const [paginationCondUnmatchedCustomers, setPaginationCondUnmatchedCustomers] = useState({ current: 1, pageSize: 10, total: 0 });

  const [infoCondFilterSync, setInfoCondFilterSync] = useState<{ matched: number[], unMatched: number[] }>({ matched: [], unMatched: [] });

  const [selectIdCondMatchedCustomers, setSelectIdCondMatchedCustomers] = useState<number[]>([]);
  const [selectedIdCondUnmatchedCustomers, setSelectedCondIdUnmatchedCustomers] = useState<Set<number>>(new Set());

  const [listCondMatchedCustomers, setListCondMatchedCustomers] = useState<ICustomer[]>([])
  const [listCondUnmatchedCustomers, setListCondUnmatchedCustomers] = useState<ICustomer[]>([])

  //Kh có dk--------------------

  //Kh có dk All--------------------
  //Kh có dk All--------------------

  const tableDataCustomers: any[] = useMemo(() => {
    return listCustomerNoCondCustomers.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listCustomerNoCondCustomers])

  const tableDataCondMatchedCustomers: any[] = useMemo(() => {
    return listCondMatchedCustomers.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listCondMatchedCustomers])

  const tableDataCondUnmatchedCustomers: any[] = useMemo(() => {
    return listCondUnmatchedCustomers.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listCondUnmatchedCustomers])

  const actionColumn: ColDef = {
    headerName: 'Nguồn',
    width: 110,
    resizable: false,
    pinned: 'left',
    suppressMovable: true,
    lockPosition: 'left',
    cellRenderer: (params: any) => {
      return !params.data.addType ?
        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              height: '30px',
              padding: '2px 8px',
              backgroundColor: '#F6FFED',
              color: '#52C41A',
              border: '1px solid #52C41A',
              fontSize: 14
            }}
          >

            <span>Thủ công</span>
          </div>
        </div >

        :

        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              height: '30px',
              padding: '2px 8px',
              backgroundColor: '#E6F7FF',
              color: '#40A9FF',
              border: '1px solid #40A9FF',
              fontSize: 14
            }}
          >

            <span>Điều kiện</span>
          </div>
        </div >
    }

  }



  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReactGroup(
      ColumnsMapShow, dataFieldsActive, actionColumn,
      (id: number, next: boolean, rowData: any) =>

        navigator(
          `/customer/list/edit`,
          {
            state: {
              firstPage: "/customer/group",
              id: rowData?.data?.id,
            }
          }
        ),
      ['own_vehicle_brand', 'own_vehicle_type_category', 'own_vehicle_model', 'own_vehicle_name', 'own_vehicle_color']
    );
  }, [ColumnsMapShow, inforAddGroup, listCustomerNoCondCustomers, listCondMatchedCustomers, inforNodeEvent]);

  const gListAllCustomer = useDebounce(async (isAllCond: boolean = true) => {
    pushLoading(true)
    if (isAllCond) {
      const result = await getListAllCustomer(permittedCategoryCarIds, unitTemp)
      if (result?.status) {
        setSelectedIdCustomerV9(result.data);
        // end test

      } else {
        pushToast(result?.message, "warning")
      }
    } else {
      //ds kh có dk lấy hết
      const conditions = filterInfoOperatoToConditions(infoOperator)
      const result = await getListAllCustomer(
        permittedCategoryCarIds,
        unitTemp, conditions, undefined, undefined
      )
      if (result?.status) {
        setSelectedIdCustomerV9(result.data);
      }
    }
    pushLoading(false)
  }, 1000)

  const gListNoCondCustomers = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const {
      listCategoryCar, listUnit, search
    } = dataFilterListNoCondCustomers

    const lastIdTmp = pageCurent === 1 ? undefined : lastId

    const result = await getListCustomerByGroup(
      permittedCategoryCarIds,
      pageSize, pageCurent, search, unitTemp ?? undefined,
      listUnit, listCategoryCar, undefined, undefined,
      undefined, undefined, lastIdTmp?.noCond
    )
    if (result?.status) {

      setlistCustomerNoCondCustomers(result.data)
      setPaginationCustomers({ current: pageCurent, total: result.total, pageSize })

      setLastId({ ...lastId, noCond: getLastIdList(result.data) })
    } else {
      // pushToast(result?.message, "warning")
    }
    pushLoading(false)

  }, 1000)


  const gListOperatorFieldGroup = useDebounce(async () => {
    pushLoading(true)
    const result = await getListOperatorFieldGroup(searchListFilter
    )
    if (result?.status) {
      setSLOperatorFieldGroup(result.data)
    }
    pushLoading(false)
  }, 1000)

  // hàm xử lý select trường V2
  const options = useMemo(() => buildOptions(sLOperatorFieldGroup), [sLOperatorFieldGroup]);

  const selectableOptions = options.filter(
    (item) => !item.isGroup
  );
  // end


  const gSyncListCustomerGroupByFilter = useDebounce(async (
    typeConditionPreview: TypeConditionPreview, pageCurent: number = 1, pageSize: number = 20
  ) => {

    const conditions = filterInfoOperatoToConditions(infoOperator)
    const listUnmatchedCustomers =
      (typeConditionPreview !== "filter" || !skipCondMatchedRef.current) ?
        Array.from(selectedIdCondUnmatchedCustomers) :
        undefined
    const dataFilter = typeConditionPreview === "condUnmatched" ? dataFilterListCondUnmatchedCustomers : undefined;

    const lastIdTmp = pageCurent === 1 ? undefined : lastId

    switch (typeConditionPreview) {
      case "filter": {
        setIsModalLoadingSync(true)
        const [resultFilterCondMatched, resultAllCustomer] = await Promise.all([
          getListConditionMatched(
            permittedCategoryCarIds, conditions,
            pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
            undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
            lastIdTmp?.condMatched
          ),
          getListAllCustomer(
            permittedCategoryCarIds,
            unitTemp, conditions, undefined, undefined
          )

        ])

        if (resultFilterCondMatched.status) {
          setListCondMatchedCustomers(resultFilterCondMatched.data.dataMatched)
          setPaginationCondMatchedCustomers({ current: pageCurent, total: resultFilterCondMatched.data.totalMatched, pageSize })
        } else {
          pushToast(resultFilterCondMatched?.message, 'warning')
        }
        setIsModalLoadingSync(false)

        if (resultAllCustomer.status) {
          setSelectedIdCustomerV9(resultAllCustomer.data);


          initialAutoCustomersRef.current = new Set(resultAllCustomer.data?.map((item: ISelectedCustomer) => item.customerId));

        } else {
          pushToast(resultAllCustomer?.message, 'warning')
        }
        setIsModalLoadingSync(false)

        //
        setIsLoadingListUnmatchedSync(true)


        setLoadingTableModal(true)
        const resultFilterCondUnMatched = await getListConditionUnMatched(
          permittedCategoryCarIds, conditions,
          pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
          undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
          lastIdTmp?.condUnmatched
        )
        if (!resultFilterCondUnMatched) {
          setLoadingTableModal(false)
          setIsLoadingListUnmatchedSync(false)
          break;
        }
        if (resultFilterCondUnMatched.status) {
          setListCondUnmatchedCustomers(resultFilterCondUnMatched.data.dataUnmatched)
          setPaginationCondUnmatchedCustomers({ current: pageCurent, total: resultFilterCondUnMatched.data.totalUnmatched, pageSize })

        } else {
          pushToast(resultFilterCondUnMatched?.message, 'warning')
        }

        setLoadingTableModal(false)

        setIsLoadingListUnmatchedSync(false)

        // gListAllCustomer(false)
        setLastId({
          ...lastId,
          condMatched: getLastIdList(resultFilterCondMatched.data.dataMatched),
          condUnmatched: getLastIdList(resultFilterCondUnMatched.data.dataUnmatched)
        })

        break;
      }
      case "condMatched": {
        setIsModalLoadingSync(true)
        const resultFilterCondMatched = await getListConditionMatched(
          permittedCategoryCarIds,
          conditions,
          pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
          undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
          lastIdTmp?.condMatched
        )
        if (resultFilterCondMatched.status) {
          setListCondMatchedCustomers(resultFilterCondMatched.data.dataMatched)
          setPaginationCondMatchedCustomers({ current: pageCurent, total: resultFilterCondMatched.data.totalMatched, pageSize })

          setLastId({ ...lastId, condMatched: getLastIdList(resultFilterCondMatched.data.dataMatched) })
        } else {
          pushToast(resultFilterCondMatched?.message, 'warning')
        }
        setIsModalLoadingSync(false)
        break;
      }
      case "condUnmatched": {

        setLoadingTableModal(true)
        const resultFilterCondUnMatched = await getListConditionUnMatched(
          permittedCategoryCarIds, conditions,
          pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
          undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
          lastIdTmp?.condUnmatched
        )
        if (!resultFilterCondUnMatched) {
          setLoadingTableModal(false)
          break;
        }
        if (resultFilterCondUnMatched.status) {
          setListCondUnmatchedCustomers(resultFilterCondUnMatched.data.dataUnmatched)
          setPaginationCondUnmatchedCustomers({ current: pageCurent, total: resultFilterCondUnMatched.data.totalUnmatched, pageSize })

          setLastId({ ...lastId, condUnmatched: getLastIdList(resultFilterCondUnMatched.data.dataUnmatched) })
        } else {
          pushToast(resultFilterCondUnMatched?.message, 'warning')
        }

        setLoadingTableModal(false)
        break;
      }

      default:
        break;
    }

    // Tắt cờ sau khi filter tải xong
    skipCondMatchedRef.current = false;
  }, 500)

  const handleChange = (field: keyof IInforAddGroup, value: any) => {
    setInforAddGroup({
      ...inforAddGroup,
      [field]: value,
    });
  };

  const handleSwitch = (value: number) => {
    if (value === CONDITION.NO) {
      setModalCondition(true)
    } else {
      setInforAddGroup({ ...inforAddGroup, type: CONDITION.NO })
      setInfoOperator(initInfoOperator)
    }
  }



  // const addCustomersInChunks = async (selectedIdCustomerV9: ISelectedCustomer[], idGroup: number) => {
  //   for (let i = 0; i < selectedIdCustomerV9.length; i += BATCH_SIZE) {
  //     const chunk = selectedIdCustomerV9.slice(i, i + BATCH_SIZE);

  //     let success = false;
  //     let retryCount = 0;

  //     while (!success) {
  //       try {
  //         await addCustomerByGroup(chunk, idGroup);
  //         success = true;
  //       } catch (error) {
  //         retryCount++;
  //         console.error(`Chunk ${i / BATCH_SIZE + 1} failed (retry ${retryCount})`, error);

  //         // delay trước khi retry
  //         await new Promise(r => setTimeout(r, 1000));
  //       }
  //     }

  //     // delay giữa các batch
  //     await new Promise(r => setTimeout(r, 50));
  //   }
  // };


  const addGroup = useThrottle(async () => {
    if (!inforAddGroup.title || inforAddGroup.title.trim() === "") {
      onSubmitFormModalAdd(false, "Tên nhóm không được để trống"!)
      return;
    }
    pushLoading(true)

    const { title, status, type, description, parentId, level } = inforAddGroup
    const unitTempTmp = unitTemp ?? undefined
    const levelTmp = inforNodeEvent?.item?.level ?? level
    const typeTmp = inforAddGroup.type


    // Build payload cho editCustomerByGroup
    const currentAutoIds = new Set(
      selectedIdCustomerV9
        .filter(c => c.addType === AddType.Auto)
        .map(c => c.customerId)
    );

    const payload: ISelectedCustomer[] = [
      // KH addType=0: giữ nguyên logic cũ (chỉ gửi những KH còn trong mảng)
      ...selectedIdCustomerV9.filter(c => c.addType === AddType.Manual),

      // KH addType=1 còn trong mảng: isDelete = 1 (active)
      ...selectedIdCustomerV9
        .filter(c => c.addType === AddType.Auto)
        .map(c => ({ ...c, isDeleted: 1 as const })),

      // KH addType=1 bị bỏ checkbox (có trong snapshot nhưng không còn trong state hiện tại)
      ...[...initialAutoCustomersRef.current]
        .filter(id => !currentAutoIds.has(id))
        .map(customerId => ({
          customerId,
          addType: AddType.Auto,
          isDeleted: 0 as const,
        })),
    ];

    const listIdAddManual = [...new Set(
      payload.filter(c => c.addType === AddType.Manual).map(c => c.customerId)
    )];
    const listIdRemoved = [...new Set(
      payload.filter(c => c.addType === AddType.Auto && c.isDeleted === 0).map(c => c.customerId)
    )];
    // console.log('[AddNewGroup] KH không thỏa điều kiện - chọn thủ công:', listIdAddManual);
    // console.log('[AddNewGroup] KH thỏa điều kiện - bị bỏ chọn:', listIdRemoved);


    const conditions = filterInfoOperatoToConditions(infoOperator)

    const result = await addListGroup(
      title, typeTmp, status,
      unitTempTmp, levelTmp, parentId,
      description, selectedIdAccount, payload.length ?? 0,
      conditions, listIdAddManual, listIdRemoved
    )
    if (result?.status) {

      const inforNodeEventTmp: NodeEvent = {
        action: "view",
        item: {
          key: result.data.id?.toString(),
          title: result.data.title,
          level: result.data.level,
          parentId: result.data.parentId,
          children: [],
        }
      }
      // await addCustomersInChunks(
      //   payload, result.data.id
      // )

      if (inforAddGroup.type) {
        const filteredInfoOperatorADD = toAddPayload(infoOperator)
        const listFilterGroup: IVConditionFilterADD = {
          typeCondition: filteredInfoOperatorADD.typeCondition,
          conditions: filteredInfoOperatorADD.conditions
        };
        const resultFilter = await addOperatorFilterGroup(
          result.data.id, [listFilterGroup]
        )
        if (resultFilter?.status) {
          onSubmitFormModalAdd(true, result?.message, inforNodeEventTmp)
        } else {
          onSubmitFormModalAdd(false, resultFilter?.message)
        }
      } else {
        onSubmitFormModalAdd(true, result?.message, inforNodeEventTmp)
      }
    } else {
      onSubmitFormModalAdd(false, result?.message)
    }
    pushLoading(false)
  }, 1000)

  const cancelAddGroup = useThrottle(async () => {
    setInforNodeEvent(undefined)
    setSelectedIdCustomerV9([])
  }, 1000)

  const onSubmitFormModalSaveFilter = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setModalCondition(false)
      pushToast(message, "success")
    }
    else {
      pushToast(message, "warning")
    }
  }

  const onPaginationCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationCustomers((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListNoCondCustomers(pageNumber, pageSize)
  }


  const onChangeTreeSelect = (value: number, node: any) => {
    setInforAddGroup({ ...inforAddGroup, parentId: value, level: node.level })
    // console.log(value, node.key)
  }

  //Kh có dk ds xem trước
  const handleChangeCondSelectIdCustomerView: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>> = (value) => {
    // Chuẩn hoá về mảng ISelectedCustomer[]
    const nextArray =
      typeof value === 'function'
        ? value(selectedIdCustomerV9) // selectedIdCustomerV9: state hiện tại
        : value;

    // Lấy danh sách customerId từ mảng value
    const valueIds = new Set(nextArray.map(v => v.customerId));

    // Giả sử selectedIdNoCondCustomerManual vẫn là Set<number>
    const nextB = new Set(
      [...selectedIdCondUnmatchedCustomers].filter(x => valueIds.has(x))
    );

    // Cập nhật state chính
    setSelectedIdCustomerV9(value);

    // Kiểm tra hai Set có giống nhau không
    const areSetsEqual =
      selectedIdCondUnmatchedCustomers.size === nextB.size &&
      [...selectedIdCondUnmatchedCustomers].every(v => nextB.has(v));

    if (!areSetsEqual) {
      setSelectedCondIdUnmatchedCustomers(nextB);
    }
  }

  //Kh có dk

  const handleChangeCondSelectIdCustomerManual = (value: Set<number>) => {
    // 1) Cập nhật danh sách selectedIdCustomerV9 (thêm + xóa theo diff)
    setSelectedIdCustomerV9(prevList => {
      // Tìm các id bị bỏ chọn (có trong selectedIdCondUnmatchedCustomers nhưng không còn trong value)
      const removedIds = new Set<number>();
      selectedIdCondUnmatchedCustomers.forEach(id => {
        if (!value.has(id)) removedIds.add(id);
      });

      // a) XÓA: loại bỏ các item Manual có customerId thuộc removedIds
      const kept = prevList.filter(item => {
        // nếu bị bỏ chọn -> loại
        if (removedIds.has(item.customerId)) return false;
        return true; // còn lại giữ
      });

      // b) THÊM: thêm các id mới từ value nếu chưa có trong kept
      const byId = new Map<number, ISelectedCustomer>(kept.map(c => [c.customerId, c]));
      value.forEach(id => {
        if (!byId.has(id)) {
          byId.set(id, { customerId: id, addType: AddType.Manual });
        }
      });

      return Array.from(byId.values());
    });

    // 2) Đồng bộ lại "bộ chọn" unmatched hiện tại
    setSelectedCondIdUnmatchedCustomers(value);
  };



  //Kh có dk
  const onPaginationCondMatchedCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    // gListCustomer_V2BySync(infoCondFilterSync.matched, 1, pageNumber, pageSize)
    gSyncListCustomerGroupByFilter("condMatched", pageNumber, pageSize)
  }
  //Kh có dk
  const onPaginationCondUnmatchedCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    // gListCustomer_V2BySync(infoCondFilterSync.unMatched, 0, pageNumber, pageSize)
    gSyncListCustomerGroupByFilter("condUnmatched", pageNumber, pageSize)
  }

  useEffect(() => {
    gListNoCondCustomers()
  }, [dataFilterListNoCondCustomers, unitTemp])

  useEffect(() => {
    if (infoOperator.typeCondition === CONDITIONGROUP.ALL) gListAllCustomer()
  }, [unitTemp, infoOperator.typeCondition])



  //Kh có dk khi thêm thủ công
  useEffect(() => {
    if (inforAddGroup.type === CONDITION.YES) {
      setIsModalLoadingSync(true)
      gSyncListCustomerGroupByFilter("condUnmatched")
      setIsModalLoadingSync(false)

    }
  }, [dataFilterListCondUnmatchedCustomers])

  //Kh có dk khi thêm thủ công
  useEffect(() => {
    if (skipCondMatchedRef.current) return;
    if (inforAddGroup.type === CONDITION.YES) {
      setIsModalLoadingSync(true)
      gSyncListCustomerGroupByFilter("condMatched")
      setIsModalLoadingSync(false)

    }
  }, [selectedIdCondUnmatchedCustomers])


  useEffect(() => {
    gListOperatorFieldGroup()
  }, [searchListFilter])

  useEffect(() => {

    if (!sLOperatorFieldGroup.length && isModalCondition)
      gListOperatorFieldGroup()

  }, [isModalCondition])

  useEffect(() => {
    // bất tắt switch áp dụng điều kiện
    const conditions = infoOperator.conditions.filter((a) => a.isAdd === true)

    if (inforNodeEvent?.action === "clone" && !conditions.length) {
      return;
    }

    setInforAddGroup(prev => ({
      ...prev,
      type: conditions.length ? CONDITION.YES : CONDITION.NO
    }))


    // hàm xử lý khi thay đổi đk thành AND - OR
    if (conditions.length) {
      setIsModalLoadingSync(true)

      // Bật cờ để không cho A tự động bắn condMatched do reset
      skipCondMatchedRef.current = true;

      //Xóa các trường đã chọn khi thay đổi đk
      setSelectedCondIdUnmatchedCustomers(new Set())
      setSelectedIdCustomerV9([])
      setSelectedIdAccount([])


      gSyncListCustomerGroupByFilter("filter")

    }
  }, [infoOperator.conditions])


  // hàm xử lý khi chọn tất cả KH
  useEffect(() => {
    // bất tắt switch áp dụng điều kiện
    if (infoOperator.typeCondition === CONDITIONGROUP.ALL) {
      setInforAddGroup(prev => ({
        ...prev,
        type: CONDITION.YES
      }))
    }

  }, [infoOperator.typeCondition])

  useEffect(() => {
    //Xóa ds điều kiện
    setSelectedIdCustomerV9([])

    if (inforAddGroup.type === CONDITION.NO) {
      setInfoOperator(initInfoOperator)
    } else {

    }
  }, [inforAddGroup.type])


  //khi thay đổi item chọn

  useEffect(() => {
    const initData = async () => {

      if (inforNodeEvent?.action === "delete") {
        return;
      }

      if (inforNodeEvent?.action === "clone") {
        if (inforNodeEvent?.dataClone) {
          const {
            parentId,
            level,
            status,
            type,
            title,
            description,
            infoFilter
          } = inforNodeEvent.dataClone;

          setInforAddGroup({
            title,
            type,
            status,
            unitScopeId: unitTemp,
            level: level ?? undefined,
            parentId: parentId || 0,
            description
          });

          if (infoFilter?.conditions?.length) {
            const infoNew =
              await gListOperatorFieldConditionsGroupByInfo(infoFilter, unitTemp);

            // nếu muốn tất cả condition được đánh dấu thêm mới
            infoNew.conditions = infoNew.conditions.map(item => ({
              ...item,
              isAdd: true
            }));

            setInfoOperator(infoNew);
          } else {
            setInfoOperator(initInfoOperator);
          }
        }
      } else {
        const { key: idGroup, level, parentId } =
          inforNodeEvent?.item || {};

        const idParentTmp = idGroup ? +idGroup : undefined;

        setInforAddGroup({
          title: "",
          type: 0,
          status: GROUPTYPE.PRIVATE,
          unitScopeId: unitTemp,
          level: level ?? undefined,
          parentId: idParentTmp,
          description: undefined
        });

        setInfoOperator(initInfoOperator);
      }
    };

    initData();
    // console.log(inforNodeEvent);

    // if (inforNodeEvent?.action === "delete") {
    //   return
    // }

    // if (inforNodeEvent?.action === "clone") {

    //   if (inforNodeEvent?.dataClone) {
    //     const { parentId, level, status, type, title, description, infoFilter } = inforNodeEvent?.dataClone

    //     const conditionsTmp = (infoFilter?.conditions || []).map(item => ({
    //       ...item,
    //       isAdd: true
    //     }))
    //     setInforAddGroup({
    //       // id: 0,
    //       title: title,
    //       type: type,
    //       status: status,
    //       unitScopeId: unitTemp,
    //       level: level ?? undefined,
    //       parentId: parentId ? parentId : 0,
    //       description: description,
    //     });

    //      if (infoFilter?.conditions) {
    //                     const infoNew = await gListOperatorFieldConditionsGroupByInfo(infoFilter);
    //                     setInfoOperator(infoNew);
    //                 }

    //     // setInfoOperator({
    //     //   typeCondition: 0,
    //     //   conditions: conditionsTmp
    //     // })
    //   }
    // } else {
    //   const { key: idGroup, level, parentId } = inforNodeEvent?.item || {};
    //   const idParentTmp = idGroup ? +idGroup : undefined

    //   setInforAddGroup({
    //     // id: 0,
    //     title: "",
    //     type: 0,
    //     status: GROUPTYPE.PRIVATE,
    //     unitScopeId: unitTemp,
    //     level: level ?? undefined,
    //     parentId: idParentTmp,
    //     description: undefined,
    //   });
    // }
  }, [inforNodeEvent, unitTemp]);
  return (
    <div className={`custom-page-css w-full flex flex-col relative ${displayType === EDisplayGroupType.TREE ? 'py-3 pr-3 pl-1' : ''} `}>

      <ModalAddAndEditCondition
        isOpen={isModalCondition}
        selectableOptions={selectableOptions}
        options={options}

        onSubmitFormModal={onSubmitFormModalSaveFilter}
        closeModal={setModalCondition}

        // moi
        infoOperator={infoOperator}
        setInfoOperator={setInfoOperator}
        setSearchListFilter={setSearchListFilter}
      />

      {/* <ModalCondition
        isOpen={isModalCondition}
        selectableOptions={selectableOptions}
        options={options}
        sLListFilter={sLListFilter}

        dataFilterList={dataFilterList}
        infoOperator={infoOperator}

        setIsModalFilterList={setIsModalFilterList}
        setDataFilterList={setDataFilterList}
        setInfoOperator={setInfoOperator}
        setSearchListFilter={setSearchListFilter}
        onSubmitFormModal={onSubmitFormModalSaveFilter}
        closeModal={setModalCondition}
      /> */}
      <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4  rounded">
        <div className="custom-page-css w-full flex items-center justify-between">
          <div className="custom-page-css w-full flex items-center gap-2 ">
            <span className='custom-page-css text-base font-regular w-100px'>Loại nhóm</span>
            <div className={`${inforAddGroup.status === GROUPTYPE.PRIVATE ? 'border-91D5FF bg-E6F7FF' : 'border'} custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
              onClick={() => handleChange("status", GROUPTYPE.PRIVATE)}>
              <div className="custom-page-css flex items-center justify-center">
                <img src={inforAddGroup.status === GROUPTYPE.PRIVATE ? user_private_active : user_private} alt="" />
              </div>
              <span
                className={`${inforAddGroup.status === GROUPTYPE.PRIVATE ? 'text-1890FF' : 'text-98A2B3'} custom-page-css text-base  font-regular`}
              >
                Nhóm riêng tư
              </span>
            </div>
            <div
              className={`${inforAddGroup.status === GROUPTYPE.SHARED ? 'border-91D5FF bg-E6F7FF' : 'border'} custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
              onClick={() => handleChange("status", GROUPTYPE.SHARED)}>
              <div className="custom-page-css flex items-center justify-center">
                <img src={inforAddGroup.status === GROUPTYPE.SHARED ? group_share_active : group_share} alt="" />
              </div>
              <span
                className={`${inforAddGroup.status === GROUPTYPE.SHARED ? 'text-1890FF' : 'text-98A2B3'} custom-page-css text-base  font-regular`}
              >
                Nhóm có thể chia sẻ
              </span>
            </div>
          </div>
          <div className="custom-page-css flex items-center gap-2">
            <span className='custom-page-css text-base font-regular whiteSpace-nowrap'>Tự động thêm khách hàng có cùng điều kiện</span>
            <Switch
              checked={inforAddGroup.type === CONDITION.YES ? true : false}
              onClick={() => handleSwitch(inforAddGroup.type)}
            />

          </div>
        </div>
        <div className="custom-page-css w-full flex items-center gap-2 ">
          <span className='custom-page-css text-base font-regular w-100px shrink-0'>Tên nhóm</span>
          {/* <div className={` custom-page-css flex items-center gap-2 border rounded px-2 py-1 cursor-pointer`}> */}
          {/* <input
                            placeholder='Nhập tên nhóm'
                            className='custom-page-css outline-none border-none '
                            value={inforAddGroup?.title}
                            onChange={(e) => handleChange("title", e.target.value)}
                        /> */}
          <TextArea
            placeholder='Nhập tên nhóm'
            className='custom-page-css w-full  '
            value={inforAddGroup?.title}
            onChange={(e) => handleChange("title", e.target.value)}
          />
          {/* </div> */}

        </div>
        <div className="custom-page-css w-full flex items-start gap-2 ">
          <span className='custom-page-css text-base font-regular w-100px shrink-0'>Mô tả</span>
          <TextArea
            placeholder='Nhập mô tả'
            className='custom-page-css w-full  '
            value={inforAddGroup?.description}
            onChange={(e) => handleChange("description", e.target.value)}
          />


        </div>
        {/* {displayType === EDisplayGroupType.LIST && */}
        <div className="custom-page-css w-full flex items-start gap-2 ">
          <span className='custom-page-css text-base font-regular w-100px shrink-0'>Nhóm chính</span>
          <TreeSelect

            className='custom-page-css w-full  border rounded'
            style={{ width: '100%' }}
            value={inforAddGroup.parentId}
            styles={{
              popup: { root: { maxHeight: 400, overflow: 'auto' } },
            }}
            placeholder="Chọn nhóm chính"
            allowClear

            treeDefaultExpandAll
            onSelect={onChangeTreeSelect}
            treeData={convertTreeForAntd(listGroup)}
          // onPopupScroll={onPopupScroll}
          />

        </div>
        {/* } */}
      </div>

      {/* Ẩn hiện component thêm nhóm Chia sẻ theo điều kiện */}
      <div className={(inforAddGroup.status === GROUPTYPE.SHARED && inforAddGroup.type === CONDITION.YES) ? '' : 'd-none'}>
        <AG_ConditionComponent
          loadingTableModal={loadingTableModal}
          memoizedColumnDefs={memoizedColumnDefs}
          infoOperator={infoOperator}
          inforAddGroup={inforAddGroup}
          paginationCustomers={paginationCustomers}

          selectedIdCustomerV9={selectedIdCustomerV9}
          selectedIdAccount={selectedIdAccount}

          setSelectedIdCustomerV9={handleChangeCondSelectIdCustomerView}
          setSelectedIdAccount={setSelectedIdAccount}

          onPaginationChange={onPaginationCustomers}

          //Kh có dk

          dataFilterListCondUnmatchedCustomers={dataFilterListCondUnmatchedCustomers}
          paginationMatchedCustomers={paginationCondMatchedCustomers}
          paginationCondUnmatchedCustomers={paginationCondUnmatchedCustomers}

          tableDataCondMatchedCustomers={tableDataCondMatchedCustomers}
          tableDataCondUnmatchedCustomers={tableDataCondUnmatchedCustomers}

          selectedIdCondUnmatchedCustomers={selectedIdCondUnmatchedCustomers}

          setDataFilterListCondUnmatchedCustomers={setDataFilterListCondUnmatchedCustomers}
          onPaginationCondMatchedCustomers={onPaginationCondMatchedCustomers}
          onPaginationCondUnmatchedCustomers={onPaginationCondUnmatchedCustomers}

          setSelectedCondIdUnmatchedCustomers={handleChangeCondSelectIdCustomerManual}

          setModalCondition={setModalCondition}
          //Kh có dk

          tableDataCondAll={tableDataCustomers}
        />
      </div>
      {/* Ẩn hiện component thêm nhóm Riêng tư theo điều kiện */}
      <div className={(inforAddGroup.status === GROUPTYPE.PRIVATE && inforAddGroup.type === CONDITION.YES) ? '' : 'd-none'}>
        <AG_CustomerList
          loadingTableModal={loadingTableModal}

          memoizedColumnDefs={memoizedColumnDefs}
          infoOperator={infoOperator}
          paginationCustomers={paginationCustomers}
          onPaginationChange={onPaginationCustomers}



          selectedIdCustomerV9={selectedIdCustomerV9}
          setSelectedIdCustomerV9={handleChangeCondSelectIdCustomerView}
          //Kh có dk
          dataFilterListCondUnmatchedCustomers={dataFilterListCondUnmatchedCustomers}
          paginationCondMatchedCustomers={paginationCondMatchedCustomers}
          paginationCondUnmatchedCustomers={paginationCondUnmatchedCustomers}

          tableDataCondMatchedCustomers={tableDataCondMatchedCustomers}
          tableDataCondUnmatchedCustomers={tableDataCondUnmatchedCustomers}

          selectedIdCondUnmatchedCustomers={selectedIdCondUnmatchedCustomers}

          setDataFilterListCondUnmatchedCustomers={setDataFilterListCondUnmatchedCustomers}
          onPaginationCondMatchedCustomers={onPaginationCondMatchedCustomers}
          onPaginationCondUnmatchedCustomers={onPaginationCondUnmatchedCustomers}


          setSelectedIdUnmatchedCustomers={handleChangeCondSelectIdCustomerManual}

          setModalCondition={setModalCondition}
          //Kh có dk
          tableDataCondAll={tableDataCustomers}


        />
      </div>

      {/* /----------------------------------------------------------------------------------------------------------------------- */}

      {/* Ẩn hiện component thêm nhóm Riêng tư  */}
      <div className={(inforAddGroup.status === GROUPTYPE.PRIVATE && inforAddGroup.type === CONDITION.NO) ? '' : 'd-none'}>
        <AG_PrivateNoAutomatic
          memoizedColumnDefs={memoizedColumnDefs}
          paginationCustomers={paginationCustomers}

          inforAddGroup={inforAddGroup}
          selectedIdCustomerV9={selectedIdCustomerV9}

          setSelectedIdCustomerV9={setSelectedIdCustomerV9}
          onPaginationCustomers={onPaginationCustomers}

          //Kh không dk
          dataFilterListNoCondCustomers={dataFilterListNoCondCustomers}

          listCustomerNoAutomatic={tableDataCustomers}
          setDataFilterListNoCondCustomers={setDataFilterListNoCondCustomers}
        //Kh không dk
        />
      </div>

      {/* Ẩn hiện component thêm nhóm có thể chia sẻ  */}
      <div className={(inforAddGroup.status === GROUPTYPE.SHARED && inforAddGroup.type === CONDITION.NO) ? '' : 'd-none'}>
        <AG_SharingNoAutomatic
          memoizedColumnDefs={memoizedColumnDefs}
          paginationCustomers={paginationCustomers}

          inforAddGroup={inforAddGroup}
          selectedIdCustomerV9={selectedIdCustomerV9}
          selectedIdAccount={selectedIdAccount}


          setSelectedIdCustomerV9={setSelectedIdCustomerV9}
          setSelectedIdAccount={setSelectedIdAccount}

          onPaginationCustomers={onPaginationCustomers}

          //Kh không dk
          dataFilterListNoCondCustomers={dataFilterListNoCondCustomers}
          listCustomerNoAutomatic={tableDataCustomers}
          setDataFilterListNoCondCustomers={setDataFilterListNoCondCustomers}
        //Kh không dk
        />
      </div>

      <div className="custom-page-css w-full flex items-center justify-end gap-2">
        <div className={` border-F5222D bg-FFF1F0 custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
          onClick={cancelAddGroup}
        >
          <CloseOutlined className='text-F5222D' />
          <span className={` custom-page-css text-F5222D text-base  font-regular`}>Huỷ bỏ</span>
        </div>
        <div className={`bg-096DD9  border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
          onClick={addGroup}
        >
          <CheckOutlined className='text-white' />
          <span className={`custom-page-css  text-white  font-regular`}>
            Lưu nhóm
          </span>
        </div>
      </div>
    </div>
  )
}
export default AddNewGroup
